var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.398 63.9931C49.9489 63.995 49.5107 63.8451 49.1459 63.5646L31.9967 50.2465L14.8475 63.5646C14.4811 63.8493 14.0397 64.0017 13.5871 64C13.1345 63.9982 12.6941 63.8423 12.3297 63.5548C11.9652 63.2673 11.6956 62.8631 11.5597 62.4006C11.4239 61.9382 11.4288 61.4414 11.5739 60.9821L18.2624 39.7608L0.927794 27.0269C0.552315 26.7514 0.268926 26.3545 0.119031 25.8942C-0.0308636 25.4338 -0.0394078 24.9342 0.094647 24.4683C0.228702 24.0024 0.49833 23.5947 0.864137 23.3046C1.22994 23.0145 1.67276 22.8574 2.12788 22.8561H23.5134L29.9672 1.58053C30.1062 1.1212 30.3775 0.72084 30.7421 0.436892C31.1067 0.152945 31.5459 0 31.9967 0C32.4474 0 32.8866 0.152945 33.2512 0.436892C33.6158 0.72084 33.8871 1.1212 34.0261 1.58053L40.4799 22.8632H61.8655C62.3212 22.863 62.7649 23.0191 63.1318 23.3086C63.4987 23.5981 63.7695 24.0058 63.9044 24.4721C64.0393 24.9383 64.0313 25.4386 63.8815 25.8996C63.7318 26.3607 63.4482 26.7582 63.0722 27.0341L45.731 39.7608L52.4155 60.9764C52.5238 61.3199 52.5542 61.6861 52.5043 62.0446C52.4544 62.4032 52.3256 62.744 52.1285 63.0387C51.9314 63.3334 51.6717 63.5737 51.3708 63.7396C51.0699 63.9056 50.7364 63.9925 50.398 63.9931Z",
    fill: "#1D619D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.01de600dc3f283a5196905a013f3aaa5.svg";
export { ForwardRef as ReactComponent };